export default __webpack_public_path__ + "static/media/02.38e50bfe.jpg";